import { MDTypography } from './MDTypography';

interface PageTitleProps {
    title: string;
}

export function PageTitle({ title }: PageTitleProps) {
    return (
        <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: '15px' }}>
            {title}
        </MDTypography>
    );
}
